/**
 * 再資源化
 * 処理工程選択 再資源化等パターン展開
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const search_recycle_disposal_pattern = {
  namespaced: true,
  state: () => ({}),
  getters: {},
  actions: {

    /**
     * 再資源化等パターン展開
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.disposer_id { Number } 処分事業者ID
     * @param param1.disposer_location_code { String } 処分事業場コード
     * @param param1.method_detail_ids { Array } JWNET取扱処分方法ID
     * @param param1.item_ids { Array } 処分前廃棄物種類
     * @param param1.recycle_disposed_item_id { Number } 処理後物ID
     * @param param1.type { String | null } 絞り込み methods: 処分場処理方法, flows: 処理フロー, null: 両方
     * @param param1.own_disposer { Boolean } 1階層目の処分業者が自社処分のみ
     * @param param1.without_invisible { Boolean } 1階層目の処分業者が自社処分のみ
     * @return {Promise<unknown>}
     */
    index ({ commit }, { disposer_id, disposer_location_code, method_detail_ids, item_ids, recycle_disposed_item_id, type, own_disposer, without_invisible }) {
      const params = {
        disposer_id: disposer_id,
        disposer_location_code: disposer_location_code,
        item_ids: item_ids,
        recycle_disposed_item_id: recycle_disposed_item_id,
        method_detail_ids: method_detail_ids,
        own_disposer: own_disposer,
        type: type,
        without_invisible: without_invisible,
      }
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposal_patterns`, { params: params }).then(data => {
          const content = data.content;
          resolve(content)
        })
      })
    },

    /**
     * 再資源化等パターン詳細展開
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.id { Number } ID
     * @param param1.type { String } パターン種別(methods: 処分場処理方法, flows: 処理フロー)
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id, type }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposal_patterns/${id}?type=${type}`).then(data => {
          const content = data.content;
          resolve(content)
        })
      })
    },
  },
  mutations: {},
}

export default search_recycle_disposal_pattern
